import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'core/libs/router';

import { createPath } from 'core/utils/url-helper';

/**
 * Компонент прокручивает окно наверх при клиентской навигации.
 * Не реагирует на изменение хеша.
 */
class ScrollToTop extends PureComponent {
  static propTypes = {
    /**
     * Данные о location пользователя полученные из react-router
     */
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      state: PropTypes.object,
    }),
  };

  componentDidUpdate(prevProps) {
    const prevPath = createPath(prevProps.location);
    const nextPath = createPath(this.props.location);
    /**
     * state.infinity используется для бесконечного скролла в статье,
     * при изменении урла в этом случае не нужно скролить наверх.
     */
    const infinity = this.props.location.state && this.props.location.state.infinity;
    const preventScrollToTop = this.props.location.state && this.props.location.state.preventScrollToTop;

    if (!preventScrollToTop && !infinity && (prevPath !== nextPath)) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

const ScrollToTopWithHOCs = withRouter(ScrollToTop);
ScrollToTopWithHOCs.displayName = 'ScrollToTop';

export { ScrollToTop as StorybookComponent };
export default ScrollToTopWithHOCs;
